export default {
    props: {
        options: {
            type: Array,
            default: () => [],
        },
        optionsLoader: {
            type: Function,
            default: null,
        },
    },
    emits: ['lazy-loaded-options'],
    data() {
        return {
            internalOptions: this.options,
            didLoadOptions: false,
            loadingOptions: false,
        };
    },
    watch: {
        options(newOptions) {
            this.internalOptions = newOptions;
            if (this.optionsLoader) {
                // always assume that options need to be loaded anew if field configuration was updated with new options
                this.didLoadOptions = false;
            } else {
                this.didLoadOptions = Array.isArray(newOptions) && newOptions.length > 0;
            }
        },
    },
    created() {
        this._resetHandler = (field, form) => {
            // we check that the form that the property belongs to is the same. This allows us to reset subform
            // properties without affecting properties on another form with the same property name
            if (form !== undefined && form != this.form) {
                return;
            }

            const matches =
                !field || field === this.property ||
                (!this.property && this.$parent && this.$parent.property === field);
            if (matches) {
                this.internalOptions = [];
                this.didLoadOptions = false;
            }
        };
        this.$root.$on('lazy-select-reset', this._resetHandler);
    },
    beforeDestroy() {
        this.$root.$off('lazy-select-reset', this._resetHandler);
    },
    methods: {
        async ensureOptionsLoaded(force = false) {
            if (!this.optionsLoader) return;

            if (!force && (this.didLoadOptions || this.loadingOptions)) {
                return;
            }

            this.loadingOptions = true;

            try {
                const loaded = await this.optionsLoader();
                this.$set(this, 'internalOptions', loaded);
                this.$emit('lazy-loaded-options', loaded);
            } finally {
                this.didLoadOptions = true;
                this.loadingOptions = false;
            }
        },
        getLabelForOptionValue(value) {
            const options = Array.isArray(this.internalOptions) ? this.internalOptions : [];
            const match = this.getFlatOptions(options).find(opt => opt.value === value);
            return match?.text ?? (typeof value === 'string' ? value : '');
        },
    },
};
